export const AREA_PAGE_PATH = '/area'
